(() => {
  'use-strict';

  const body = document.querySelector('body');

  function init(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('init' in element.dataset) {
        return;
      }
      element.dataset.init = true;

      let timeoutMenu;
      const linkTriggers = element.querySelectorAll('a[aria-controls].lvl-0');
      const siteHeader = element.closest('.js-site-header');
      const compareLink = element.querySelector('.js-compare-link');

      if (compareLink !== null) {
        const initialMenuCompare = compareLink.previousElementSibling;
        const mainMenu = compareLink.closest('.menu-inner.lvl-0');
        document.addEventListener('breakpointChange', (event) => {
          if (!(event.detail.breakpoints.includes('desktop-large'))) {
            // Mobile / tablet case
            // Insert the compare link at the end of main menu
            mainMenu.insertAdjacentElement('beforeend', compareLink);
          } else {
            // Desktop case
            // Insert the compare link at is initial place (after .menu-list)
            initialMenuCompare.insertAdjacentElement('afterend', compareLink);
          }
        }, false);
      }

      // build categoryLink + replace real link by button for accessibility
      linkTriggers.forEach((linkTrigger) => {
        const href = linkTrigger.getAttribute('href');
        const target = document.getElementById(linkTrigger.getAttribute('aria-controls'));
        linkTrigger.removeAttribute('href'); // TODO:FRONT:OPTIM - removeAttribute not working on FF, not blocking, try to fix if possible
        linkTrigger.outerHTML = linkTrigger.outerHTML.replace(/^<a/, '<button').replace(/^<\/a/, '</button');
        const categoryLink = document.createElement('a');
        categoryLink.innerHTML = Drupal.t('See the whole section');
        categoryLink.classList.add('MainMenu-categoryLink', 'js-category-link');
        categoryLink.setAttribute('href', href);
        target.querySelector('.menu-inner').appendChild(categoryLink);
      });

      function clickOutsideHandle(trigger, event) {
        let targetEl = event.target; // clicked element
        do {
          if (targetEl === element.closest('nav')) {
            // This is a click inside, does nothing, just return.
            return;
          }
          // Go up the DOM
          targetEl = targetEl.parentNode;
        } while (targetEl);
        // This is a click outside.
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (viewportWidth >= window.breakpointsDefinition['desktop-large']) {
          // eslint-disable-next-line no-use-before-define
          toggle(trigger, false);
        }
      }

      const toggle = (trigger, state) => {
        if ((trigger.target.getAttribute('aria-expanded') === 'true') !== state) {
          // state change we do actions
          trigger.setAttribute('aria-expanded', state);
          trigger.target.classList.add('-isAnimated');
          trigger.target.setAttribute('aria-expanded', state);
          body.classList.toggle('-mainMenuSubLvlIsExpanded', state);
          const removeAnimatedClass = () => {
            trigger.target.classList.remove('-isAnimated');
            trigger.target.addEventListener('animationend', removeAnimatedClass);
          };
          trigger.target.addEventListener('animationend', removeAnimatedClass);

          if (state === false) { // close actions
            trigger.links.forEach((link) => {
              link.removeEventListener('blur', link.blurLink);
            });
            document.removeEventListener('click', clickOutsideHandle);
          } else { // open actions
            trigger.links = trigger.target.querySelectorAll('a, button');
            trigger.links.forEach((link) => {
              link.blurLink = (event) => {
                // check if the new target is in the same parent or not
                const parentMenuItem = event.target.closest('.menu-item.lvl-0');
                if (event.relatedTarget !== null && parentMenuItem !== event.relatedTarget.closest('.menu-item.lvl-0')) {
                  const parentTrigger = parentMenuItem.querySelector('.menu-link.lvl-0');
                  toggle(parentTrigger, false);
                }
              };
              link.addEventListener('blur', link.blurLink);
            });
            document.addEventListener('click', clickOutsideHandle.bind(null, trigger));
          }
        }
      };

      const buttonTriggers = element.querySelectorAll('button[aria-controls].lvl-0');

      buttonTriggers.forEach((trigger) => {
        trigger.target = document.getElementById(trigger.getAttribute('aria-controls'));

        const toggleAndCloseSiblings = () => {
          buttonTriggers.forEach((elt) => {
            // if element is not current or current is opened
            if (elt !== trigger || elt.target.getAttribute('aria-expanded') === 'true') {
              toggle(elt, false);
            } else { // if current is closed
              toggle(elt, true);
            }
          });
        };

        // TODO:FRONT:OPTIM - try to REFACTOR blurHandle and blurLink to use one methode only,
        // be careful to removeEventListener scope
        const blurHandle = (event) => {
          const parentMenuItem = event.target.closest('.menu-item.lvl-0');
          if (event.relatedTarget !== null && parentMenuItem !== event.relatedTarget.closest('.menu-item.lvl-0')) {
            const parentTrigger = parentMenuItem.querySelector('.menu-link.lvl-0');
            toggle(parentTrigger, false);
          }
          event.target.blurListenerAttached = false;
          trigger.removeEventListener('blur', blurHandle);
        };
        const focusHandle = (event) => {
          if (!event.target.blurListenerAttached) {
            event.target.blurListenerAttached = true;
            event.target.addEventListener('blur', blurHandle);
          }
        };
        const clickHandle = (event) => {
          toggleAndCloseSiblings();
          event.preventDefault();
          if (!event.target.blurListenerAttached) {
            event.target.blurListenerAttached = true;
            event.target.addEventListener('blur', blurHandle);
          }
        };

        trigger.addEventListener('click', clickHandle);
        trigger.addEventListener('focus', focusHandle);

        const buttonClose = document.createElement('button');
        buttonClose.innerHTML = Drupal.t('Close');
        buttonClose.classList.add('MainMenu-close');
        buttonClose.setAttribute('type', 'button');
        trigger.target.appendChild(buttonClose);
        buttonClose.addEventListener('click', clickHandle);
      });

      const calcButtonsPos = () => {
        const headerRect = siteHeader.getBoundingClientRect();
        const middleHeaderRect = headerRect.left + headerRect.width / 2;
        buttonTriggers.forEach((trigger) => {
          const triggerRect = trigger.getBoundingClientRect();
          const middleTriggerRect = triggerRect.left + triggerRect.width / 2;
          const deltaFromMiddleHeader = Math.round(middleTriggerRect - middleHeaderRect);
          trigger.target.style.setProperty('--arrow-delta-middle', `${deltaFromMiddleHeader}px`);
        });
      };

      window.addEventListener('resize', () => {
        if (timeoutMenu) {
          window.cancelAnimationFrame(timeoutMenu);
        }
        /// Wrap this in requestAnimantionFrame to avoid performances issues
        timeoutMenu = window.requestAnimationFrame(() => {
          calcButtonsPos();
        });
      }, false);

      setTimeout(calcButtonsPos, 100);
    });
  }

  Drupal.behaviors.menuAccordion = {
    attach: () => {
      const elements = document.querySelectorAll('.js-menu-accordion');
      if (elements.length !== 0) {
        init(elements);
      }
    },
  };
})();
